<template>
  <div class="hints-editor-container">
    <div>
      <h1>Edit Editorial</h1>
    </div>
    <div class="flex items-center items-baseline">
      <label for="editorial name">NAME:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="questionEditorial.name"
          v-validate="'required'"
          type="text"
          name="editorial name"
          class="course-create-input"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("editorial name") }}
        </small>
      </div>
    </div>
    <div class="flex items-center items-baseline">
      <label for="editorial point">POINTS:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="questionEditorial.points"
          v-validate="'required|numeric|min_value:1'"
          type="text"
          name="editorial point"
          class="course-create-input"
        />
        <small class="err-msg text-red block mt-2">
          {{ veeValidateErrors.first("editorial point") }}
        </small>
      </div>
    </div>
    <div class="flex items-center items-baseline">
      <label class="mr-2">CMS ID:</label>
      <div class="w-full m-2 input-wrapper">
        <input
          v-model="questionEditorial.cms_id"
          type="text"
          class="course-create-input"
        />
      </div>
    </div>
    <div class="row">
      <div class="small-8 columns mt-6">
        <simplemde
          v-model="questionEditorial.content"
          v-validate="'required'"
          uniqueId="edyst-hint-content"
          name="editorial content"
        >
        </simplemde>
        <small class="err-msg text-red">
          {{ veeValidateErrors.first("editorial content") }}
        </small>
      </div>
    </div>
    <div class="small-12 columns">
      <button
        class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-1 hover:bg-green-900"
        @click="updateEditorial"
      >
        Update Editorial
      </button>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import simplemde from "@/components/simpleMarkdownEditor/SimpleMarkdown"

export default {
  components: { simplemde },
  data() {
    return {
      type: 11,
      questionEditorial: {},
    }
  },
  created() {
    this.getQuestion()
  },
  methods: {
    getQuestion() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.questionEditorial = res.data.data
          window.pageTitle = `Edit - ${this.questionEditorial.name}`
        })
        .catch(error => {
          this.$noty.error(`Failed to get the editorial question ${error}`)
        })
    },
    updateEditorial() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fix the error and try again")
          return
        }
        this.axios({
          method: "put",
          url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
          data: this.questionEditorial,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
        })
          .then(() => {
            this.$noty.success("Editorial is updated successfully")
            this.$router.push({ name: "EditorialList" })
          })
          .catch(error => {
            this.$noty.error(`Failed to update the editorial ${error}`)
          })
      })
    },
  },
}
</script>

<style scoped>
.is-invalid {
  border-color: #ff5151;
}
.input-wrapper {
  margin: 0.5rem auto;
  margin-left: 2rem;
}
.course-create-input {
  width: 57%;
}
</style>
